export default ({ request }) => ({
  orderInspectionGoodsSaveApi(data = {}) {
    return request({
      url: '/factory/order/inspection/goods/save',
      method: 'post',
      data,
    })
  },
  orderInspectionGoodsListApi(data = {}) {
    return request({
      url: '/factory/order/inspection/goods/list',
      method: 'post',
      data,
    })
  },
  orderInspectionGoodsBatchDelApi(data = {}) {
    return request({
      url: '/factory/order/inspection/goods/batch/del',
      method: 'post',
      data,
    })
  },
})
